import CloudOffOutlinedIcon from '@mui/icons-material/CloudOffOutlined';
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import SearchOffOutlinedIcon from '@mui/icons-material/SearchOffOutlined';
import { SvgIconProps } from '@mui/material/SvgIcon';
import { ComponentType } from 'react';
import { defineMessage, MessageDescriptor } from 'react-intl';
import { ViewErrorKind } from '../../utils/async-view/view-error-kind';

const notFoundTitle = defineMessage({
  id: 'common.viewError.notFound.title',
  defaultMessage: 'No encontramos lo que buscabas',
});

const notFoundHelp = defineMessage({
  id: 'common.viewError.notFound.help',
  defaultMessage: 'El elemento no existe o fue eliminado. Revisá el enlace o volvé al listado.',
});

const forbiddenTitle = defineMessage({
  id: 'common.viewError.forbidden.title',
  defaultMessage: 'No tenés permisos para ver esto',
});

const forbiddenHelp = defineMessage({
  id: 'common.viewError.forbidden.help',
  defaultMessage: 'Si creés que deberías tener acceso, pedíselo a un administrador.',
});

const unavailableTitle = defineMessage({
  id: 'common.viewError.unavailable.title',
  defaultMessage: 'No pudimos conectarnos',
});

const unavailableHelp = defineMessage({
  id: 'common.viewError.unavailable.help',
  defaultMessage: 'Revisá tu conexión e intentá de nuevo en unos instantes.',
});

const errorTitle = defineMessage({
  id: 'common.viewError.error.title',
  defaultMessage: 'No pudimos cargar esta información',
});

const errorHelp = defineMessage({
  id: 'common.viewError.error.help',
  defaultMessage: 'Intentá de nuevo. Si el problema continúa, contactanos.',
});

interface ViewErrorPresentation {
  readonly icon: ComponentType<SvgIconProps>;
  readonly title: MessageDescriptor;
  readonly help: MessageDescriptor;
}

/** User-facing icon and copy for each error kind, keyed so ids stay static for the extractor. */
export const viewErrorPresentation: Record<ViewErrorKind, ViewErrorPresentation> = {
  notFound: { icon: SearchOffOutlinedIcon, title: notFoundTitle, help: notFoundHelp },
  forbidden: { icon: LockOutlinedIcon, title: forbiddenTitle, help: forbiddenHelp },
  unavailable: { icon: CloudOffOutlinedIcon, title: unavailableTitle, help: unavailableHelp },
  error: { icon: ErrorOutlineOutlinedIcon, title: errorTitle, help: errorHelp },
};
